import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appBtnVariableDirective]'
})

export class BtnVariableDirectiveDirective implements AfterViewInit   {
  constructor(
    private el: ElementRef,
    private render: Renderer2,
    private router: Router) {}
  ngAfterViewInit() {
    const strong = this.el.nativeElement.querySelectorAll('strong')[0];
    this.render.listen(strong, 'click', () => {
     this.router.navigate(['request-access']);
    });
  }
}
